"use client";

import { Suspense } from "react";

import {
  AcademicInformationPage,
  ApplicationFormController,
  GuardianInformationPage,
  PersonalStatementPage,
  ProgramSelectionPage,
  StudentInformationPage1,
} from "@up/application-form";

const pages = [
  StudentInformationPage1,
  GuardianInformationPage,
  ProgramSelectionPage,
  AcademicInformationPage,
  PersonalStatementPage,
];

export default function ApplicationPage() {
  return (
    <div className="theme-white">
      <Suspense>
        <ApplicationFormController pages={pages} />
      </Suspense>
    </div>
  );
}
